export default __webpack_public_path__ + "static/media/27.3e42f300.jpg";